<template>
  <div class="about-team">
    <div class="about-team-title">华院团队</div>
    <div class="about-team-leader">
      <img :src="about_team_xxh" alt="宣晓华" />
      <div class="about-team-leader-bg">
        <span class="about-team-leader-position">华院创始人&董事长</span>
        <span class="about-team-leader-name">宣晓华 | Michael Xuan</span>
      </div>
    </div>
    <ul class="about-team-honour-list">
      <li
        class="about-team-honour-item"
        v-for="(item, index) in honour"
        :key="`about-team-honour-item${index + 1}`"
      >
        <strong>·</strong>{{ item }}
      </li>
    </ul>
    <p class="content-txt">
            在宣博士的引领下，我们组建了一支高素质的专业化研发人才梯队。截至2025年12月31日，我们研发雇员，占截至同日我们的雇员总数约62.1%，成员包括北京大学、清华大学、复旦大学、浙江大学、上海交通大学及海外知名高校的毕业生。团队专业背景涵盖基础数学、计算数学、计算机科学、认知科学、运筹控制及统计学等交叉学科领域。这种多学科交叉融合的团队结构，构成了公司在认知智能领域持续创新的核心人才基础。
    </p>
    <!-- <p class="content-txt" style="margin: 10px 0">
      华院计算与复旦大学建立了深度合作，双方就大数据产学研结合、人才培养以及相关交流进行长期深度合作。通过学术和产业紧密连接，实现产学研协同创新模式。
    </p>
    <p class="content-txt">
      华院计算发起成立斯梅尔研究院，由世界著名数学家史蒂芬·斯梅尔(Stephen Smale)
      命名并担任名誉主席，致力于使用算法和大数据，为基础科学和其它科学研究提供基础支撑，构建更好的研究方法。并携手国内外高校和机构的杰出学者，通过联合项目研究及项目资助等形式，积极探索将高校和机构研究、企业研究成果在大数据人工智能产业中的应用。
    </p> -->
  </div>
</template>
<script>
import about_team_xxh from "@/../static/img/about/about_team_xxh.png";
export default {
  data() {
    return {
      about_team_xxh,
      honour: [
        "中国工业与应用数学学会 监事会监事、CSIAM会士",
        "中国人工智能学会逻辑专委会　常务委员。",
        "复旦大学大数据学院　外聘教授。",
        "复旦大数据研究院学术委员会　委员。",
        "斯梅尔数学与计算研究院　执行院长。"
      ]
    };
  }
};
</script>
<style lang="less" scoped>
.about-team {
  padding: 44px 64px 96px;
  background: #ffffff;

  .about-team-title {
    font-size: 40px;
    color: #08204d;
    line-height: 56px;
    text-align: center;
  }

  .about-team-leader {
    display: flex;
    justify-content: center;
    height: 398px;
    margin-top: 48px;

    > img {
      width: 264px;
      height: 398px;
    }

    .about-team-leader-bg {
      padding: 36px 40px;
      background: url("../../../static/img/about/about_team_bg.png") no-repeat 0
        0 / 100%;

      .about-team-leader-position {
        font-size: 26px;
        color: #08204d;
        line-height: 36px;
      }

      .about-team-leader-name {
        display: flex;
        flex-direction: columns;
        font-size: 32px;
        color: #08204d;
        line-height: 44px;
      }
    }
  }

  .about-team-honour-list {
    margin: 32px 0 64px;
    list-style-position: inside;

    .about-team-honour-item {
      font-size: 24px;
      font-weight: 400;
      color: #08204d;
      line-height: 40px;
      list-style-position: inside;

      > strong {
        margin-right: 14px;
      }
    }
  }

  .content-txt {
    font-size: 24px;
    font-weight: 400;
    color: #08204d;
    line-height: 40px;
    margin-bottom: 40px;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/about/team.vue